import { Component } from "@angular/core";

@Component({
    templateUrl: "./unauthorized.html",
    styleUrls: []
})
export class UnauthorizedComponent { }